import React from "react";
import CommodityReport from "../modules/CommodityReport";

export function CommodityReportPage() {
  return <CommodityReport />;
}
